import { AppProps } from "next/app";
import { CacheProvider } from "@emotion/react";
import createEmotionCache from "../src/app/emotionCache";

function MyApp({ Component, pageProps }: AppProps<{ nonce: string }>) {
  const cache = createEmotionCache(pageProps.nonce);
  return (
    <CacheProvider value={cache}>
      <Component {...pageProps} />
    </CacheProvider>
  );
}

export default MyApp;
